export default {
  text: '#f1f1f1',
  primary: '#5f4e4e',
  secondary: '#5f4e4e',
  background: '#1b1b1b',
  backgroundSecondary: '#fff',
  light: '#FFF',
  dark: '#202020'
}
